var irreducible = require('./irreducible');
var isNumber = require('./isNumber');
module.exports = irreducible('Number', isNumber);